/** @jsx jsx */
import React, { useEffect } from "react";
import { jsx, css } from "@emotion/core";
import { Link } from "react-router-dom";
import _get from "lodash/get";
import Cookies from "js-cookie";

import { colors } from "../../theme";
import config from "../../config";

import Layout from "../../components/Layout";
import Header from "../../components/Header";
import ColoredH1 from "../../components/ColoredHeader";
import HeroImage from "../../components/HeroImage";
import hero from "./assets/hero.jpg";

import { exposeCookies } from "../Form/apiCalls";
import { populateAndPushDataLayerForGoogleAnalytics } from "../../utils/Tracking";

const ColouredBody = ({ children }) => (
    <p
        css={css`
            &&& {
                color: ${colors.secondary7};
                font-size: 24px;
                font-weight: 800;
            }
        `}
    >
        {children}
    </p>
);

const Highlight = ({ children }) => (
    <span
        css={css`
            color: ${colors.primary5};
        `}
    >
        {children}
    </span>
);

const ActivationEmailBody = ({ emailAddress }) => (
    <ColouredBody>
        We’ve sent an activation email to{" "}
        <Highlight>
            {emailAddress ? emailAddress : "your email address"}
        </Highlight>
        . Follow the link to log into the application.
    </ColouredBody>
);

const SuccessBody = ({ emailAddress }) => (
    <ColouredBody>
        You've signed up to MyTutor using{" "}
        <Highlight>
            {emailAddress ? emailAddress : "your email address"}
        </Highlight>
        . Follow the link below to set your password and start your application.
        <br />
        <br />
        <a href={config.LOGIN_PAGE}>Log in</a>
    </ColouredBody>
);

const Success = ({ location }) => {
    useEffect(() => {
        async function fetchCookiesAndSendGAData() {
            await exposeCookies();
            populateAndPushDataLayerForGoogleAnalytics();

            const userTrackingId = Cookies.get("user_tracking_id");

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "GAevent",
                event_category: "register",
                event_label: "tutor",
                ga_user_id: `T${userTrackingId}`,
            });
        }
        fetchCookiesAndSendGAData();
    }, []);

    var email = _get(location, "state.emailAddress", "your email address");

    var hasUniEmail = _get(location, "state.hasAccessToUniEmail", true);

    return (
        <>
            <Header />
            <Layout>
                <div className="inner-container">
                    <HeroImage
                        src={hero}
                        alt="Illustration of tutoring a lesson online"
                    />
                    <ColoredH1 color={colors.accent5} className="success">
                        Thanks!
                    </ColoredH1>
                    {hasUniEmail ? (
                        <ActivationEmailBody emailAddress={email} />
                    ) : (
                        <SuccessBody emailAddress={email} />
                    )}
                </div>
            </Layout>
        </>
    );
};

export const Failure = () => (
    <>
        <Header />
        <Layout>
            <div className="inner-container">
                <HeroImage
                    src={hero}
                    alt="Illustration of tutoring a lesson online"
                />
                <ColoredH1 color={colors.accent5} className="success">
                    Sorry
                </ColoredH1>
                <ColouredBody>
                    There was a problem completing your signup. Please{" "}
                    <Link to="/signup/form">
                        <Highlight>return to the form</Highlight>
                    </Link>{" "}
                    and try again
                </ColouredBody>
            </div>
        </Layout>
    </>
);

export default Success;
